import { CSSObject } from "@emotion/react";

export const DoubleBarLabelPlacementOptions = {
  top: "top",
  bottom: "bottom",
} as const;

export interface DoubleBarData {
  value: number | undefined;
  label: string;
  labelPlacement: (typeof DoubleBarLabelPlacementOptions)[keyof typeof DoubleBarLabelPlacementOptions];
  style?: CSSObject | undefined;
}
